<template>
  <div>
  <!-- MAIN -->
  <div class="breadcrumbs ace-save-state" id="breadcrumbs">
    <ul class="breadcrumb">
      <li>
        <i class="ace-icon fa fa-home home-icon"></i>
        <a href="#/">ダッシュボード</a>
      </li>
      <li class="active">個人コード一覧</li>
    </ul><!-- /.breadcrumb -->
  </div>
  <div class="page-header">
    <div class="checkbox">
      <label class="checkbox-box">
        <input name="scorp" type="checkbox" class="ace pCodeId" checked="checked" @click="addRomoveScorp('pCodeId', 'pCodeId')">
        <span class="lbl">個人コード</span>
      </label>
      <label class="checkbox-box">
        <input name="scorp" type="checkbox" class="ace userId" checked="checked" @click="addRomoveScorp('userId', 'userId')">
        <span class="lbl">ユーザーID</span>
      </label>
      <span class="input-icon search-box">
        <input type="text" placeholder="選択項目にチェックして検索" class="nav-search-input" id="nav-search-input" autocomplete="off">
        <i class="ace-icon fa fa-search nav-search-icon"></i>
      </span>
      <button class="btn-cusstom green-btn" type="button" @click="search()">検索</button>
      <button v-if="selectedPcodeId.length>0" class="btn-cusstom black-btn" type="button" href="#process" data-toggle="modal" @click="resetStatus()">チェックした個人コードを無効化</button>
    </div>
  </div><!-- /.page-header -->
  <!-- END MAIN -->
  <div class="page-content">
    <div class="alert alert-danger" v-if="errorMessageLogs!==''">
      {{ errorMessageLogs }}
    </div>
    <div id="loading" v-if="loading"><div class="loadingMsg"></div></div>
    <div class="scroll-data-content">
        <div class="pull-right">
          <a class="option_button" data-toggle="collapse" data-parent="#accordion" href="#collapseOne" aria-expanded="false">表示オプション&nbsp;
            <i class="bigger-110 ace-icon fa fa-angle-down" data-icon-hide="ace-icon fa fa-angle-up" data-icon-show="ace-icon fa fa-angle-down"></i>
          </a>
        </div>
        <div class="clearfix" style="clear:both">
          <div id="accordion">
            <div class="panel-collapse collapse" id="collapseOne" aria-expanded="false" style="height: 0px;">
              <div class="panel-body">
                <div class="control-group">
                  <label class="control-label bolder blue display_block">表示項目</label>
                  <div class="checkbox table_items">
                    <label>
                      <input name="pcode_id" type="checkbox" class="ace" disabled checked="checked">
                      <span class="lbl"> 個人コード</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="pcode_user_name" type="checkbox" class="ace" checked="checked" v-model="checkedColumnNames" value="userId">
                      <span class="lbl">ユーザーID</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="pcode_type" type="checkbox" class="ace" @click="ShowHideColumn" checked="checked" v-model="checkedColumnNames" value="type">
                      <span class="lbl">コード種別</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="pcode_status" type="checkbox" class="ace" @click="ShowHideColumn" checked="checked" v-model="checkedColumnNames" value="status">
                      <span class="lbl">ステータス</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="pcode_date" type="checkbox" class="ace" @click="ShowHideColumn" checked="checked" v-model="checkedColumnNames" value="registered">
                      <span class="lbl">登録日</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="pcode_updated" type="checkbox" class="ace" @click="ShowHideColumn" checked="checked" v-model="checkedColumnNames" value="updated">
                      <span class="lbl">更新日</span>
                    </label>
                  </div>
                </div>
                <div class="control-group">
                  <label class="control-label bolder blue display_block">ページことに表示する項目</label>
                  <select id="pageSizeOptions" class="first-child last-child" @change="handleSizeChange" v-model="selected">
                    <option v-for="pageSize in pageSizeOptions" v-bind:value="pageSize" v-bind:key="pageSize">
                    {{ pageSize }} 件
                    </option>
                  </select>
                  <div class="checkbox table_items">
                    <label>
                      <input type="checkbox" class="ace" checked v-model="notLoadAllDataPcode" @click="reLoadData()">
                      <span class="lbl">有効なデーターのみ表示</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <table id="simple-table" class="table  table-bordered table-hover dataTable" v-if="list!=null">
          <thead>
            <tr>
              <th class="center">
                <label class="pos-rel">
                  <input type="checkbox" class="ace" v-model="selectAll">
                  <span class="lbl"></span>
                </label>
              </th>
              <th id="pcode_id" class="pcode_id sorting" @click="sort('pCodeId', 'pcode_id')">個人コード</th>
              <th id="pcode_user_name" class="pcode_user_name sorting" @click="sort('userId', 'pcode_user_name')" v-bind:class="{'none': checkColumnShowHide('userId')}">ユーザーID</th>
              <th id="pcode_type" class="pcode_type sorting center" @click="sort('type', 'pcode_type')" v-bind:class="{'none': checkColumnShowHide('type')}">個人コード種別</th>
              <th id="pcode_status" class="center pcode_status sorting" @click="sort('isValid', 'pcode_status')" v-bind:class="{'none': checkColumnShowHide('status')}">ステータス</th>
              <th id="pcode_date" class="center pcode_date sorting" @click="sort('registered', 'pcode_date')" v-bind:class="{'none': checkColumnShowHide('registered')}">登録日</th>
              <th id="pcode_updated" class="center pcode_updated sorting" @click="sort('updated', 'pcode_updated')" v-bind:class="{'none': checkColumnShowHide('updated')}">更新日</th>
            </tr>
          </thead>
          <tbody v-for="(item, index) in list" :key="index">
            <tr v-bind:class="{'selected': rowSelected(item.pCodeId)}" :id="item.pCodeId">
              <td class="center">
                <label class="pos-rel">
                  <input type="checkbox" class="ace" :value="item.pCodeId" v-model="selectedPcodeId">
                  <span class="lbl"></span>
                </label>
              </td>
              <td class="pcode_id" @click="showdetail">{{item.pCodeId}}</td>
              <td class="pcode_user_name" @click="showdetail" v-bind:class="{'none': checkColumnShowHide('userId')}">{{item.userId}}</td>
              <td class="center pcode_type" @click="showdetail" v-bind:class="{'none': checkColumnShowHide('type')}">{{item.type}}</td>
              <td class="center pcode_status" @click="showdetail" v-bind:class="{'none': checkColumnShowHide('status')}">
                <span v-if="item.isValid">有効</span>
                <span v-else >無効</span>
              </td>
              <td class="center pcode_date" @click="showdetail" v-bind:class="{'none': checkColumnShowHide('registered')}">{{ converDate(item.registered) }}</td>
              <td class="center pcode_updated" @click="showdetail" v-bind:class="{'none': checkColumnShowHide('updated')}">{{ converDate(item.updated) }}</td>
            </tr>
            <tr class="detail-row">
              <td v-bind:colspan ="columnCount">
                <app-pcode-detail v-bind:item="item" v-bind:userId="item.userId"></app-pcode-detail>
              </td>
            </tr>
          </tbody>
        </table>
        <table id="simple-table" class="table  table-bordered table-hover dataTable" v-else>
          <thead>
            <tr>
              <th class="center">
                <label class="pos-rel">
                  <input type="checkbox" class="ace">
                  <span class="lbl"></span>
                </label>
              </th>
              <th>個人コード</th>
              <th>ユーザーID</th>
              <th>個人コード種別</th>
              <th>ステータス</th>
              <th>登録日</th>
              <th>更新日</th>
            </tr>
          </thead>
          <tbody>
            <tr><td colspan="7">{{message}}</td></tr>
          </tbody>
        </table>
    </div><!-- /.row -->
    <div class="row pd-t-10">
      <div class="col-xs-12">
        <div class="dataTables_paginate paging_simple_numbers" v-if="pages>0">
          <paginate
            :page-count="pages"
            :page-range="3"
            :margin-pages="2"
            :click-handler="handleCurrentChange"
            :prev-text="'<<'"
            :next-text="'>>'"
            :container-class="'pagination'"
            :page-class="'page-item'">
          </paginate>
        </div>
      </div>
    </div>
  </div>
  <!-- プロフィールModal -->
  <div id="process" class="modal fade" tabindex="-1">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
          <h3 class="smaller lighter frofile-title no-margin">個人コードを無効化</h3>
        </div>
        <div class="modal-body">
          <span class="progress-question">チェックした個人コードを一括無効化します、よろしいですか？</span>
          <div class="progress" v-bind:class="{'progress-striped':!success , active:!success, hide:!success}">
            <div class="progress-bar" :style="progressWidth">
            <span>{{ Math.round(progress) }}%</span>
            </div>
          </div>
          <span class="success-label" v-if="successPcode>0">{{countPcode}}件中{{successPcode}}件を無効化しました。</span>
          <div v-if="errorMessage.length>0">
          <span class="error-box-title">無効化失敗</span>
          <div class="error-box">
            <template v-for="item in errorMessage">
              <p v-html="item" :key="item"></p>
            </template>
          </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-sm btn-success pull-right" style="width:100px" data-dismiss="modal" v-if="success">OK</button>
          <button class="btn btn-sm btn-danger pull-right" style="width:100px" v-if="!success" :disabled="isDisabled" @click="updateAllStatus()">実行</button>
        </div>
      </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
  </div>
  <a href="javascript:void(0)" class="float" id="menu-share">
    <i class="fa fa-plus my-float"></i>
  </a>
  <ul class="add_btn_list">
    <li>
      <router-link :to="{ name: 'pcodeadd'}" class="adduser">
        <i class="ace-icon fa fa-credit-card my-float"></i>
      </router-link>
      <div class="label-container">
        <div class="label-text">個人コード登録</div>
        <i class="fa fa-play label-arrow"></i>
      </div>
    </li>
    <li>
      <router-link :to="{ name: 'pcodeimport'}" class="adduserExport">
        <i class="ace-icon glyphicon glyphicon-upload my-float"></i>
      </router-link>
      <div class="label-container-export">
        <div class="label-text">CSVインポートで個人コード登録</div>
        <i class="fa fa-play label-arrow"></i>
      </div>
    </li>
  </ul>
  </div>
</template>

<script>
import * as Config from '../../config'
import moment from 'moment'
import PcodeDetail from './PcodeDetail.vue'

export default {
  data () {
    return {
      list: null,
      errorMessageLogs: '',
      message: 'データー取得中',
      checkedColumnNames: [
        'userId',
        'type',
        'status',
        'registered',
        'updated'
      ],
      notLoadAllDataPcode: true,
      scorp: ['pCodeId', 'userId'],
      pages: 0,
      error: null,
      pCodeConfigTypes: null,
      pageSizeOptions: [25, 50, 100, 1000],
      listQuery: {
        currPage: 1,
        pageSize: 100
      },
      progress: 0,
      selected: 100,
      selectedPcodeId: [],
      success: false,
      loading: false,
      isDisabled: false,
      errorMessage: [],
      successPcode: 0,
      errorName: '',
      columnCount: 0,
      countPcode: 0,
      exeCount: 0,
      percent: 0,
      totalData: 0
    }
  },
  components: {
    appPcodeDetail: PcodeDetail
  },
  watch: {
    'progress': 'checkProgress',
    'checkedColumnNames': 'updateChecked',
    exeCount: function (newVal, oldVal) {
      var vm = this
      if (newVal > 0 && newVal < vm.countPcode) {
        vm.updateStatus(this.selectedPcodeId[newVal], vm.percent, newVal)
      } else if (newVal > 0 && newVal === vm.countPcode) {
        this.exeCount = 0
        this.getList()
      }
    }
  },
  created () {
    if (typeof localStorage.notLoadAllDataPcode === 'undefined') {
      localStorage.setItem('notLoadAllDataPcode', 'yes')
    }
    if (typeof localStorage.pageSizePcode === 'undefined') {
      localStorage.setItem('pageSizePcode', 100)
      this.selected = localStorage.pageSizePcode
    } else {
      this.selected = localStorage.pageSizePcode
    }
    if (typeof localStorage.pcodeSortKey === 'undefined') {
      localStorage.setItem('pcodeSortKey', 'pCodeId')
    }
    if (typeof localStorage.pcodeSortName === 'undefined') {
      localStorage.setItem('pcodeSortName', 'desc')
    }
    if (typeof localStorage.checkedPcode === 'undefined') {
      localStorage.setItem('checkedPcode', this.checkedColumnNames)
    } else {
      var tempData = []
      this.checkedColumnNames.forEach(function (item) {
        if (localStorage.checkedPcode.indexOf(item) !== -1) {
          tempData.push(item)
        }
      })
      this.checkedColumnNames = tempData
    }
    this.getList()
  },
  mounted () {
    var vm = this
    $('#nav-search-input').keyup(function (e) {
      if (e.keyCode === 13) {
        vm.search()
      }
    })
    this.columnCount = this.checkedColumnNames.length + 2
    if (localStorage.notLoadAllDataPcode === 'yes') {
      this.notLoadAllDataPcode = true
    } else {
      this.notLoadAllDataPcode = false
    }
  },
  computed: {
    progressWidth: function () {
      return 'width:' + this.progress + '%'
    },
    selectAll: {
      get: function () {
        return this.list ? this.selectedPcodeId.length === this.list.length : false
      },
      set: function (value) {
        var selectedPcodeId = []
        if (value) {
          this.list.forEach(function (item) {
            selectedPcodeId.push(item.pCodeId)
          })
        }
        this.selectedPcodeId = selectedPcodeId
      }
    }
  },
  methods: {
    reLoadData () {
      if (localStorage.notLoadAllDataPcode === 'yes') {
        localStorage.setItem('notLoadAllDataPcode', 'no')
      } else {
        localStorage.setItem('notLoadAllDataPcode', 'yes')
      }
      this.pages = 0
      this.listQuery.currPage = 1
      this.getList()
    },
    resetView () {
      $('#simple-table').find('tr.detail-row').removeClass('open')
      $('div.panel-collapse').removeClass('in')
      $('a.accordion-toggle').addClass('collapsed')
      $('a.accordion-toggle i').addClass('fa-angle-right')
      $('a.accordion-toggle i').removeClass('fa-angle-down')
    },
    updateChecked () {
      localStorage.setItem('checkedPcode', this.checkedColumnNames)
      this.columnCount = this.checkedColumnNames.length + 2
    },
    checkColumnShowHide (columnName) {
      if (localStorage.checkedPcode.indexOf(columnName) !== -1) {
        return false
      } else {
        return true
      }
    },
    converDate (t) {
      return moment(new Date(t * 1000)).format('YYYY/MM/DD HH:mm')
    },
    converTimestamp (t) {
      return parseInt(new Date(t) / 1000)
    },
    // スマートフォン詳細を開く
    showdetail: function (e) {
      e.preventDefault()
      $(e.target).closest('tr').next().toggleClass('open')
    },
    // 実行状態チェック
    checkProgress () {
      if (Math.round(this.progress) === 100) {
        this.success = true
        this.selectedPcodeId = []
      }
    },
    // チェックしたスマートフォンを無効化すり前にリセット
    resetStatus () {
      $('.progress').addClass('hide')
      $('.progress-question').html('チェックした個人コードを一括無効化します、よろしいですか？')
      this.progress = 0
      this.exeCount = 0
      this.success = false
      this.isDisabled = false
      this.errorMessage = []
      this.successPcode = 0
      this.countPcode = 0
    },
    // 行にチェックする
    rowSelected (phoneId) {
      if (jQuery.inArray(phoneId, this.selectedPcodeId) !== -1) {
        return true
      } else {
        return false
      }
    },
    // チェックしたユーザーを無効化
    updateStatus (pCodeId, percent, i) {
      var vm = this
      this.$http.put(Config.PCODE_LIST_API + '/' + encodeURIComponent(pCodeId), {isValid: false})
        .then(response => {
          vm.progress += percent
          vm.successPcode += 1
          vm.exeCount++
        })
        .catch((error) => {
          this.progress += percent
          this.exeCount++
          switch (error.status) {
            case 400:
              this.errorName = '入力したパラメーターが誤っています。入力内容をご確認ください。'
              break
            case 403:
              this.errorName = '個人コードの追加権限がありません。'
              break
            case 404:
              this.errorName = '該当するデーターがありません。'
              break
            case 409:
              this.errorName = '入力された個人コードは既に使用されています。他の個人コードを入力してください。'
              break
            case 420:
              this.errorName = '個人コード登録数が上限に達しています。'
              break
            case 500:
              this.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            case 503:
              this.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            default:
              this.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
          }
          var rowstatus = pCodeId + '>><span>' + this.errorName + '</span>'
          this.$set(this.errorMessage, i, rowstatus)
        })
    },
    updateAllStatus () {
      var vm = this
      vm.isDisabled = true
      if (this.selectedPcodeId.length > 0) {
        this.countPcode = this.selectedPcodeId.length
        $('.progress').removeClass('hide')
        $('.progress-question').html('処理状況')
        vm.percent = (100 / this.selectedPcodeId.length)
        vm.updateStatus(this.selectedPcodeId[0], vm.percent, 0)
      } else {
        alert('少なくても個人コードを１つ選んでください。')
      }
    },
    // 検索項目チェンジ
    addRomoveScorp (classname, scorpname) {
      if ($('.' + classname).prop('checked')) {
        this.scorp.push(scorpname)
      } else {
        this.scorp.splice($.inArray(scorpname, this.scorp), 1)
      }
    },
    // 検索
    search () {
      this.loading = true
      var apiLink = ''
      this.errorMessageLogs = ''
      if (this.scorp.length > 0) {
        this.resetView()
        window.scrollTo(0, 0)
        this.listQuery.currPage = 1
        this.pages = 0
        var keyword = $('.nav-search-input').val()
        keyword = keyword.replace(/\s/g, ',')
        keyword = encodeURIComponent(keyword)
        if (localStorage.notLoadAllDataPcode === 'yes') {
          apiLink = Config.PCODE_LIST_API + '?limit=' + localStorage.pageSizePcode + '&page=' + this.listQuery.currPage + '&keyword=' + keyword + '&scorp=' + this.scorp + '&sortKey=' + localStorage.pcodeSortName + ':' + localStorage.pcodeSortKey + '&isValid=true'
        } else {
          apiLink = Config.PCODE_LIST_API + '?limit=' + localStorage.pageSizePcode + '&page=' + this.listQuery.currPage + '&keyword=' + keyword + '&scorp=' + this.scorp + '&sortKey=' + localStorage.pcodeSortName + ':' + localStorage.pcodeSortKey
        }
        this.$http.get(apiLink)
          .then(response => {
            if (response.body.maxRecords > 0) {
              this.list = response.body.pCodes
              this.pages = Math.ceil((response.body.maxRecords) / localStorage.pageSizePcode)
              for (var i = 0; i < this.list.length; i++) {
                this.getTypeInfo(this.list[i].type, i)
              }
            } else {
              this.loading = false
              this.pages = 0
              this.list = null
              this.message = '該当するデーターがありません。'
            }
            console.log(response)
            this.loading = false
          })
          .catch((error) => {
            this.list = null
            this.pages = 0
            this.loading = false
            this.message = '該当するデーターがありません。'
            switch (error.status) {
              case 400:
                this.errorMessageLogs = '入力したパラメーターが誤っています。入力内容をご確認ください。'
                break
              case 403:
                this.errorMessageLogs = '個人コードの取得権限がありません。'
                break
              case 404:
                this.errorMessageLogs = '該当するデーターがありません。'
                break
              case 500:
                this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                break
              case 503:
                this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                break
              default:
                this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
                break
            }
          })
      } else {
        alert('少なくても検索項目を１つ選んでください。')
        this.loading = false
      }
    },
    // ソート
    sort (sortkey, elementname) {
      this.loading = true
      if ($('#' + elementname).hasClass('sorting_asc')) {
        $('#simple-table>thead>tr>th').removeClass('sorting_asc')
        $('#simple-table>thead>tr>th').removeClass('sorting_desc')
        $('#' + elementname).removeClass('sorting_asc')
        $('#' + elementname).addClass('sorting_desc')
        localStorage.setItem('pcodeSortName', 'desc')
        localStorage.setItem('pcodeSortKey', sortkey)
      } else {
        $('#simple-table>thead>tr>th').removeClass('sorting_asc')
        $('#simple-table>thead>tr>th').removeClass('sorting_desc')
        $('#' + elementname).removeClass('sorting_desc')
        $('#' + elementname).addClass('sorting_asc')
        localStorage.setItem('pcodeSortName', 'asc')
        localStorage.setItem('pcodeSortKey', sortkey)
      }
      this.getList()
    },
    // １ページに表示する項目数
    handleSizeChange () {
      this.listQuery.pageSize = $('#pageSizeOptions').val()
      localStorage.setItem('pageSizePcode', this.listQuery.pageSize)
      this.listQuery.currPage = 1
      this.pages = 0
      this.getList()
    },
    // ページネーションチェンジ
    handleCurrentChange (val) {
      this.selectedPcodeId = []
      this.listQuery.currPage = val
      this.getList()
      $('#simple-table').find('tr.detail-row').removeClass('open')
      window.scrollTo(0, 0)
    },
    // コラム表示する
    ShowHideColumn: function (e) {
      var $tbl = $('#simple-table')
      var colToHide = $tbl.find('.' + $(e.target).attr('name'))
      $(colToHide).toggle()
    },
    // NFC読み取り設定種別取得
    getTypeInfo (type, i) {
      var vm = this
      if (type === 0) {
        vm.list[i].type = 'NFCカード'
      } else {
        vm.list[i].type = 'テンキー入力'
      }
    },
    // スマートフォン一覧
    getList () {
      this.loading = true
      this.errorMessageLogs = ''
      var apiLink = ''
      this.resetView()
      if (this.list !== null) {
        var keyword = $('.nav-search-input').val()
        keyword = keyword.replace(/\s/g, ',')
        keyword = encodeURIComponent(keyword)
      } else {
        keyword = ''
      }
      if (localStorage.notLoadAllDataPcode === 'yes') {
        apiLink = Config.PCODE_LIST_API + '?limit=' + localStorage.pageSizePcode + '&page=' + this.listQuery.currPage + '&keyword=' + keyword + '&scorp=' + this.scorp + '&sortKey=' + localStorage.pcodeSortName + ':' + localStorage.pcodeSortKey + '&isValid=true'
      } else {
        apiLink = Config.PCODE_LIST_API + '?limit=' + localStorage.pageSizePcode + '&page=' + this.listQuery.currPage + '&keyword=' + keyword + '&scorp=' + this.scorp + '&sortKey=' + localStorage.pcodeSortName + ':' + localStorage.pcodeSortKey
      }
      this.$http.get(apiLink)
        .then(response => {
          console.log(response)
          if (response.body.maxRecords > 0) {
            this.loading = false
            this.list = response.body.pCodes
            this.pages = Math.ceil((response.body.maxRecords) / localStorage.pageSizePcode)
            for (var i = 0; i < this.list.length; i++) {
              this.getTypeInfo(this.list[i].type, i)
            }
          } else {
            this.list = null
            this.message = '該当するデーターがありません。'
            this.loading = false
            this.list = null
            this.pages = 0
          }
        })
        .catch(error => {
          this.loading = false
          this.list = null
          this.message = '該当するデーターがありません。'
          switch (error.status) {
            case 400:
              this.errorMessageLogs = '入力したパラメーターが誤っています。入力内容をご確認ください。'
              break
            case 403:
              this.errorMessageLogs = '個人コードの取得権限がありません。'
              break
            case 404:
              this.errorMessageLogs = '該当するデーターがありません。'
              break
            case 500:
              this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            case 503:
              this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            default:
              this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              break
          }
        })
    }
  }
}
</script>

<style>
.checkbox label, .radio label {
  padding-left: 10px!important
}
.checkbox-box{
  margin-right: 15px
}
.edit-bottom,.delete-bottom{
  width: 100%;
  margin-bottom: 15px
}
.fa-6{
  font-size: 3em;
}
.fa-3{
  font-size: 2em;
}
.table>tbody>tr>td{
  vertical-align: middle;
  padding: 5px;
  font-size: 16px;
}
.dataTables_paginate .pagination {
  margin: 0;
}
.table-bordered>tbody>tr>td{
  border-right:3px solid #fff;
}
.label-sm {
  padding: 10px;
  font-size: 16px;
  line-height: 1;
  height: auto;
}
.table-detail .profile-info-name{
  width: 195px
}
.device{
  margin-top: 50px;
  border-top: 2px solid #ccc
}
.table-detail .accordion-style1.panel-group .panel-heading .accordion-toggle.collapsed{
  font-size: 18px
}
.table-detail .accordion-style1.panel-group .panel-heading .accordion-toggle{
  font-size: 18px
}
.add-buttom{
  margin-bottom: 10px
}
.modal-content .form-horizontal .control-label{
  text-align: left;
}
.chosen-container-single .chosen-single{
  border-radius: 0px;
  height: 35px;
  font-size: 16px;
  line-height: 35px!important;
}
.chosen-container-single{
  width: 100%!important
}
.chosen-container{
  margin-bottom: 10px
}
.dataTable>thead>tr>th[class*=sorting_]{
  color: #707070
}
.modal-content .form-horizontal .control-label{
  text-align: left;
}
.chosen-container-single .chosen-single{
  border-radius: 0px;
  height: 35px;
  font-size: 16px;
  line-height: 35px!important;
}
.chosen-container-single{
  width: 100%!important
}
.chosen-container{
  margin-bottom: 10px
}
.dataTable>thead>tr>th[class*=sorting_]{
  color: #707070
}
</style>



// WEBPACK FOOTER //
// src/views/pcode/PcodeList.vue